import { render, staticRenderFns } from "./profileBuInubbm.vue?vue&type=template&id=57ed5627&scoped=true&"
import script from "./profileBuInubbm.vue?vue&type=script&lang=js&"
export * from "./profileBuInubbm.vue?vue&type=script&lang=js&"
import style0 from "./profileBuInubbm.vue?vue&type=style&index=0&id=57ed5627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed5627",
  null
  
)

export default component.exports